/**
 * Persistent Jarvis mount. Rendered ONCE, high in the tree (App level), so the
 * assistant survives navigation between /doserne pages instead of unmounting
 * with each page's DoserneShell. Only renders for admins on /doserne routes.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { DoserneAuthProvider, useDoserneAuth } from "./doserneAuth";
import { useLang } from "./i18n";
import JarvisWidget from "./JarvisWidget";

function JarvisInner() {
  const { user, authHeader } = useDoserneAuth();
  const { lang } = useLang();
  if (!user?.is_admin) return null;
  return <JarvisWidget authHeader={authHeader} lang={lang} />;
}

export default function DoserneJarvisMount() {
  const loc = useLocation();
  // Persist on the Doserne portal AND the Doserne-admin pages that live under
  // /admin but are backed by the Doserne session (so the guided tour survives
  // navigating to the Project Overview / Capacity planner).
  const onDoserne = loc.pathname.startsWith("/doserne");
  const onDoserneAdmin = /^\/admin\/(project-overview|capacity)/.test(loc.pathname);
  // Underlag edit/sign pages (used live in the guided tour). JarvisInner still
  // gates on user?.is_admin, so a real client opening a sign link sees nothing.
  const onUnderlag = /^\/(underlag\/(edit|sign)|u)\//.test(loc.pathname);
  if (!onDoserne && !onDoserneAdmin && !onUnderlag) return null;
  // Not on the public login / sign / reset routes. (`verify` — the public
  // certificate page — is allowed so the guided tour can show a diploma;
  // JarvisInner still gates on is_admin, so real visitors never see Jarvis.)
  if (/\/(logg-inn|reset-password|kontrakt|avtale|verifiser)/.test(loc.pathname)) return null;
  return (
    <DoserneAuthProvider>
      <JarvisInner />
    </DoserneAuthProvider>
  );
}
